import { render } from "./Main.vue?vue&type=template&id=501118f6"
const script = {}
script.render = render

export default script